import styled from 'styled-components';
import PropTypes from 'prop-types';

const colorSelection = (props) => {
    if (props.selected) {
        return props.theme.colors.primary;
    }

    if (props.disabled) {
        return '#e0e0e0';
    }

    return props.theme.colors.darygray;
};

const Tab = styled.li`
  text-align: left;
  list-style: none;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  text-transform: uppercase;
  outline: none;
  color: ${colorSelection};
  padding: 20px 40px 20px 0;
  text-decoration: ${props => (props.selected ? 'underline' : null)};
  border-bottom: ${props => (props.selected ? 'none' : null)};
  font-size: 16px;
`;

Tab.propTypes = {
    selected: PropTypes.bool,
    disabled: PropTypes.bool
};

export default Tab;



// WEBPACK FOOTER //
// ./src/components/atoms/tabs/Tab.js